import React, { useState } from "react";
import { ItemType } from "antd/es/menu/interface";
import FlatList from "common/Lists/FlatList";
import BottomDrawer from "common/Drawers/BottomDrawer";
import styled from "styled-components";
import Text from "common/Typography/Text";
import { DropdownProps } from "common/Dropdown/Dropdown";

const MobileDropdown = (props: DropdownProps) => {
  const [shouldCloseDrawer, setShouldCloseDrawer] = useState(false);

  const renderOption = ({ item }: { item: ItemType }) => {
    if (item === null) return;
    if ("type" in item && item.type === "divider") {
      return <Divider />;
    }
    const showIcon = "icon" in item;
    return (
      <Option
        as="div"
        key={item.key}
        onClick={(e) => {
          setShouldCloseDrawer(true);
          if ("onClick" in item) {
            item.onClick?.(e);
          }
        }}
        className={`mobile-dropdown-menu-item ${item.className}`}
      >
        {showIcon && item.icon}
        <span style={{ marginLeft: showIcon ? 8 : 0 }}>{item.label}</span>
      </Option>
    );
  };

  const content = (
    <FlatListWrapper>
      <FlatList data={props.menu?.items || []} renderContent={renderOption} />
    </FlatListWrapper>
  );

  return (
    <BottomDrawer
      content={content}
      title={props.title}
      triggerElement={props.children}
      contentStyle={{ padding: 0 }}
      shouldCloseDrawer={shouldCloseDrawer}
      setShouldCloseDrawer={setShouldCloseDrawer}
      className="mobile-dropdown"
    />
  );
};

export default MobileDropdown;

const FlatListWrapper = styled.div`
  width: 100%;
  flex: 1;
  overflow: hidden;
`;
const Option = styled(Text)`
  display: flex;
  align-items: center;
`;
const Divider = styled.div`
  height: 1px;
  background: ${(p) => p.theme.colors.lightBorderGrey};
  width: 100%;
`;
